import React from 'react';
import { Button } from 'js/components/common/Button';
import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import style from '../index.scss';

export type GetRenderCancelButtonType = {
    showCancelBonusPopup: (event: React.MouseEvent<HTMLElement>, bonusName: string, bonusInstanceCode: string) => void;
    translate: ITranslateMethod;
    tabIndex?: number;
};

export const getRenderCancelMobileButton = ({
    translate,
    showCancelBonusPopup,
    tabIndex = 0
}: GetRenderCancelButtonType) => (value?: { bonusName: string; bonusInstanceCode: string }): React.ReactNode => {
    if (!value) {
        return null;
    }

    const { bonusName, bonusInstanceCode } = value;

    return (
        <>
            <div className={style.cancelMobileWrapper}>
                <div className={style.cancelBonusText}>{translate('playtech.mobile.system.balance.cancelBonus')}</div>
                <Button
                    tabIndex={tabIndex}
                    color='info'
                    onClick={(
                        event: React.MouseEvent<HTMLElement, MouseEvent>
                    ) => showCancelBonusPopup(event, bonusName, bonusInstanceCode)}
                >
                    {translate('playtech.mobile.system.balance.removeBonus')}
                </Button>
            </div>
        </>
    );
};

export const getRenderCancelButton = ({
    translate, showCancelBonusPopup, tabIndex = 0
}: GetRenderCancelButtonType) => (bonusName: string, bonusInstanceCode: string): React.ReactNode => {
    if (!bonusName || !bonusInstanceCode) {
        return null;
    }

    return (
        <>
            <div className={style.cancelWrapper}>
                <Button
                    tabIndex={tabIndex}
                    color='info'
                    onClick={(event) => showCancelBonusPopup(event, bonusName, bonusInstanceCode)}
                >
                    {translate('playtech.mobile.system.balance.removeBonus')}
                </Button>
            </div>
        </>
    );
};
